export default {
  login: {
    phonename: "蘑菇云手机",
    title: "欢迎使用蘑菇云手机",
    login: "登录",
    registered: "注册",
    forgotPassword: "忘记密码"
  },
  reg: {
    reg: "欢迎注册蘑菇云手机",
    findPass: "找回密码",
    haveUser: "已有账号",
    backLogin: "返回登录",
    mesCode: "获取验证码",
    try:'s后重试',
    noSms:'收不到短信？'
  },
  index: {
    title: "蘑菇云",
    buy: "订购/续费",
    integral: "积分/优惠券",
    defName: "蘑菇云用户",
    userMan: "账户管理",
    activationCode: "激活码",
    buyRecord: "订购记录",
    logout: "退出登录",
    userInfo: "个人信息",
    eidtPass: "修改密码",
    olaPass: "原密码",
    newPass: "新密码",
    confPass: "确认密码",
    exchangeCode: "兑换码",
    selectPhone: "选择云手机",
    addPhone: "新增云手机",
    exchangeDescTit: "兑换说明",
    exchangeDesc1: "每个激活码只能激活一次;",
    exchangeDesc2:
      "若您通过非官方渠道获取的激活码，无法激活，蘑菇云将概不负责;",
    exchangeDesc3: "该激活码最终解释权归蘑菇云所有。",
    exchangeDesc4:
      "确认兑换后，兑换的云手机将在5分钟内到账。超时云手机未分配到账，此激活码不会被激活使用。",
    nowExchange: "立即兑换",
    exchangeRecord: "兑换记录",
    myEq: "我的设备",
    appNav: "上传应用",
    fileNav: "上传文件",
    serNav: "扩展服务",
    time: "剩余时间",
    mesCenter: "消息中心"
  },

  pad: {
    resource: "品牌",
    group: "分组增减云机",
    addGroup: "加入此分组",
    goNoGroup: "移至待分组",
    moveGroup: "分组间移动",
    moveNoGroup: "移至未分组",
    goToGroup: "移动至分组",
    noGroup: "未分组",
    appOp: "应用安装/卸载",
    allSelect: "全选",
    noSelect: "反选",
    selected: "已选",
    muchOp: "批量操作",
    rebPhone: "重启云机",
    reSetPhone: "恢复出厂设置",
    changeIp: "切换IP代理",
    ipAgent: "IP代理",
    nowIp: "当前IP地址",
    openIp: "开启IP代理",
    switching: "切换方式",
    switchingIp: "切换新IP",
    bindIp: "绑定当前IP",
    selectLine: "选择线路",
    random: "随机",
    manuallyChoose: "手动选择",
    cityList: "城市列表",
    provinces: "省份",
    city: "城市",
    syncPhone: "云机同步",
    headCode: "云机识别码",
    live: "多路实时直播",
    log: "日志调试",
    clearLog: "清除日志",
    ADB: "高级调试ADB",
    changeRotateTrue: "切换横屏",
    changeRotateFalse: "切换竖屏",
    setSize: "150%大小",
    setSize1: "标准大小",
    setSize2: "75%大小",
    setSize3: "60%大小",
    setSize4: "50%大小",
    refresh: "刷新",
    loading: "加载中...",
    syncing: "应用同步中...",
    noPad: "暂无云机",
    noMore: "没有更多了",
    replacement: "一键换机",
    name: "云手机",
    phoneName: "云机名称",
    offline: "连接已断开，请关闭后重新连接",
    linking: "连接中...",
    menuTit: "多任务",
    homeTit: "Home键",
    backTit: "返回键",
    screenshotsTit: "屏幕截图",
    voiceTit: "音量键",
    voiceUp: "音量加",
    voiceDown: "音量减",
    clipboardTit: "剪贴板",
    rotateTit: "横竖屏",
    hd: "高清",
    ordinary: "普通",
    highSpeed: "高速",
    speed: "极速",
    state: "状态",
    apkMan: "应用管理",
    apkInstall: "已安装应用",
    changeApkInstall: "请勾选需安装的应用",
    authEq: "授权设备",
    copyCon: "近期复制或剪切过得文字",
    getIpPort: "获取远程IP和端口",
    conIp: "远程连接IP",
    conPort: "远程连接端口",
    copy: "复制",
    changeRightsPack: "换机权益包",
    changeRightsTit: "今日免费次数已用完，选择权益包换机更优惠，是否继续？",
    selectGroup: "选择分组/云机",
    yesHandout: "确认分发",
    number: "云机编号",
    closeRoot: "关闭root",
    openRoot: "开启root"
  },

  order: {
    conf: "订单确认",
    packageType: "套餐类型",
    number: "订购数量",
    ci: "次",
    total: "共",
    stand: "台",
    day: "天",
    a: "个",
    yuan: "元",
    window: "窗口",
    extend: "【续】",
    title: "我的订单",
    No: "订单号",
    time: "下单时间",
    content: "订购内容",
    amount: "数量",
    state: "订单状态",
    details: "订单详情",
    type: "订购类别",
    windowOpen: "窗口多开服务",
    longTime: "订购时长",
    theDay: "当天",
    oneWeek: "一周内",
    oneMonth: "一月内",
    threeMonth: "三月内",
    halfYear: "半年内",
    oneYear: "一年内",
    assignmentFa: "分配失败",
    assignmentSu: "分配成功",
    timeout: "订单超时",
    payType: '支付类型',
    payTime: '支付时间',
    orderName: '名称',
    orderType: '套餐类型',
    orderNum: '订购数量',
    orderPayPrice: '支付金额',
    orderTips: '扫码支付成功，正在跳转至云机列表，请稍后...',
  },
  pay: {
    way: "支付方式",
    money: "支付金额",
    mogu: "支付宝支付",
    wechat: '微信支付',
    conf: "请前往支付窗口完成支付",
    ing: "支付中",
    yes: "我已付款",
    for: "去支付",
    toBePaid: "待支付",
    success: "支付成功",
    renewal: "续费成功",
    scan: "扫码支付",
    qrCode: "请用微信扫描上方二维码进行支付",  
    orderPayTimeOut: '支付超时，请关闭弹框重新下单',
  },
  sync: {
    tit: "请控制好直播源文件大小，过于追求清晰度会产生丢包、卡顿等情况。",
    comOper: "完成操作",
    master: "主控",
    setMaster: "设为主控"
  },

  apk: {
    tit: "应用列表",
    upload: "上传应用",
    name: "应用名称",
    search: "搜索",
    apkName: "APK名称",
    version: "版本号",
    man: "管理",
    handout: "应用分发",
    del: "删除",
    delApk: "删除应用",
    confDelApk: "确定要删除应用",
    sendCon:
      "根据应用分发数量、应用包大小以及所安装的云机数量，你可能需要等待几分钟至几十分钟，确认后立即开始安装!",
    waitCon: "应用分发指令已发送，安装需要几分钟时间，请耐心等候！",
    know: "知道了"
  },
  file: {
    tit: "文件列表",
    upload: "上传文件",
    name: "文件名称",
    moreDel: "批量删除",
    moreHandout: "批量分发",
    type: "文件类别",
    time: "上传时间",
    handout: "文件分发",
    delFile: "删除文件",
    confDelFile: "确定要删除",
    pic: "图片",
    video: "视频",
    script: "脚本",
    other: "其他",
    hanouts: "文件批量分发",
    sendCon:
      "根据文件分发数量、文件大小以及所分发的云机数量，你可能需要等待几分钟，确认后立即开始分发！",
    waitCon: "文件分发指令已发送，上传需要几分钟时间，请耐心等候！",
    size: "文件大小",
    uploadProgress: "上传进度"
  },
  coupons: {
    coupons: "优惠券",
    noUse: "暂无可用",
    reselect: "重新选择",
    usable: "可用优惠券",
    usingRange: "使用范围",
    usingTime: "使用时间",
    no: "暂无优惠券",
    notAvailable: "不可用优惠券",
    discount: "折扣券",
    kims: "代金券",
    fullReduction: "满减券",
    cumulativeIntegral: "累计积分",
    integral: "积分",
    rmb: "人民币",
    integralInfo: "积分明细",
    integralDetails: "积分收支明细",
    padHowLong: "拥有云手机后可兑换时长",
    buyPhone: "购买云手机",
    howLong: "兑换时长",
    needConsume: "需消耗",
    unused: "未使用",
    used: "已使用",
    expired: "已过期",
    discountName: "折扣",
    discountType: "折",
    consumption: "即将消耗",
    integralHowLong: "积分兑换云手机时长， 是否兑换？",
    confChange: "确认兑换",
    integralType: "积分类型",
    getTime: "领取时间",
    exchangeRecord: "积分兑换记录",
    changeTime: "兑换时间",
    consumptionIntegral: "消耗积分"
  },
  subscribe: {
    tit: "选择品牌",
    memory: "内存",
    storage: "存储",
    system: "系统",
    virtualMachine: "虚拟机",
    free: "免费赠送",
    limitFree: "限时优惠",
    onePad: "1台起订",
    zhang: "张",
    usable: "可用",
    refund: "付款后即代表您已认可该云机符合您的要求，不再退款",
    cpu: "6核",
    cpuPlus: "6核加强版",
    system: "安卓7.12",
    unlimited: "无限制",
    havelimits: "有限制",
    experience: "体验",
    order: "订购",
    renew: "续费",
    cpu8: "8核",
    system12: "安卓12",
    system14: "安卓14"
  },

  sys: {
    tit: "消息中心",
    mes: "系统消息",
    allread: "全部已读",
    announcement: "系统公告"
  },
  service: {
    none: "若所订购的云机到期，扩展服务也将自动取消",
    ordered: "已订购",
    name: "扩展服务",
    content: "订购内容",
    contact: "订购说明",
    rtml:
      "欢迎订购多路实时直播RTMP URL，订购成功后，订购期内您订购的所有云机均支持此项功能。蘑菇云仅提供多路实时直播功能，用户如在直播平台存在违规，与本平台无关。",
    rtmlContact:
      "每个直播源文件需要订购1个RTMP URL，如多台云机同时播放同一直播源文件，则只需订购1个RTMP URL。请控制好直播源文件大小，过于 追求清晰度会产生丢包、卡顿等情况。",
    buyWindow: "已订购窗口",
    time: "订购时间",
    windowNum: "订购窗口数",
    selectedPad: "已选云机",
    cancle: "若所订购的云机到期，扩展服务也将自动取消",
    free: "功能免费",
    limitedTimeFree: "限时免费",
    documentation: "说明文档",
    camera: "远程虚拟相机",
    use: "使用",
    download: "APK下载",
    buy: "购买",
    apkDownload: "请用浏览器扫码下载APK至真机",
    masterEquipment: "设备大师",
    virtualOrientation: "虚拟定位"
  },
  list: {
    addGroup: "新建分组",
    padName: "云机名",
    apkNum: "应用数",
    editEqName: "修改设备名称",
    sort: "自动按数字，英文字母，中文拼音首字母排序",
    editGroup: "编辑分组",
    delGroup: "删除分组",
    delTit:
      "删除分组后，会同时清理该分组下云机上的应用，如需继续，请点击“确定”；点击“取消”按钮撤回本次操作。"
  },

  label: {
    phone: "手机号",
    pic: "图形验证码",
    mesCode: "短信验证码",
    pass: "登录密码",
    inviteCode: "邀请码",
    expireT: "到期时间",
    apkNum: "应用安装数",
    normal: "正常",
    fault: "故障",
    prompt: "提示",
    No: "序号",
    operation: "操作",
    details: "详情",
    open: "展开",
    close: "收起",
    selected: "已选择"
  },
  form: {
    phone: "请输入手机号",
    checkPhone: "请输入正确的手机号",
    noPhone: "该手机号码没有注册！",
    yesPhone: "该手机号号码已经注册！",
    defUser: "请输入手机号，默认作为登录账号",
    password: "请输入登录密码",
    oldpassword: "请输入原密码",
    newPass: "请输入新密码",
    checkNewPass: "请再次输入新密码",
    pic: "请输入图形验证码",
    checkPass: "密码为8-20位数字和英文字母组成!",
    againPass: "新密码与旧密码不可一致！",
    nickName: "昵称",
    email: "邮箱",
    titEmail: "请输入邮箱地址",
    checkEmail: "请输入正确的邮箱地址",
    code: "请输入激活码，不区分大小写",
    nullCode: "激活码不能为空！",
    checkCode: "激活码格式错误！",
    mesCode: "请输入短信验证码",
    inviteCode: "请输入邀请码",
    content: "请输入内容",
    pSelect: "请选择",
    changeRtmp: "选择RTMP URL",
    noBuyRtmp: " 您还未购买多路实时直播RTMP URL！",
    buyWindow: "请先购买窗口多开服务！",
    maxWindow: "超过最大窗口数！",
    pSelectApk: "请先选择应用",
    waitApk: "应用安装/卸载需要几分钟时间，请耐心等待",
    noGroup: "不允许对未分组设备进行该操作，请先对其进行分组",
    selectTwo: "请至少选择2台云机",
    selectOne: "请至少选择1台云机",
    maxSelect: "云机同步最多支持40台设备",
    pSelectPad: "请先选择云机",
    pSelectGroup: "请先选择分组",
    appName: "输入应用名称",
    appId: "输入应用APPID",
    fileName: "输入文件名称",
    fileType: "请选择文件类别",
    pSelectFile: "请先选择文件",
    apkType: "请选择APK文件类型上传",
    fileSize: "文件大小不得超过2G",
    fileSize1: "文件大小不得超过1G",
    apkRepeat: "该应用已存在",
    analysisEr: "解析错误",
    noAnalysis: "应用无法解析，请重新上传",
    pUploadApk: "请先上传应用",
    pUploadFile: "请先上传文件",
    selectFile: "选择文件",
    nameLong: "文件名称过长",
    fileRepeat: "该文件已存在",
    selectPad: "至少选择一个分组/云机",
    orderTime: "请选择下单时间",
    orderNo: "请输入订单号",
    selectRenew: "请选择要续费的云机",
    noRead: "请选择未读公告",
    selectBindPad: "选择绑定的云机",
    maxWindowNum: "多开窗口购买总数不能超过7个",
    padName: "输入云机名称",
    eqName: "请输入设备名",
    groupName: "请输入分组名称",
    checkGroupName: "仅支持数字、中文字符、英文字母、-和_字符",
    checkGroupName1: "分组名称不支持输入特殊字符",
    maxText: "分组名称不能超过 20 个字符",
    checkEqName: "设备名称不支持输入特殊字符",
    codeHasUsed: "该激活码已使用",
    codeHasExpired: "该激活码已过期"
  },

  but: {
    confEdit: "确认修改",
    cancel: "取 消",
    yes: "确 定",
    empty: "清空",
    close: "关闭",
    upload: "上传",
    back: "返回",
    yesPay: "确认支付"
  },
  mes: {
    logSu: "登录成功",
    picEr: "上传图片尺寸过大！",
    eidtSu: "修改成功",
    eidSuLo: "修改成功,请重新登录",
    exchangeSu: "兑换成功，您兑换的云机将在5分钟内到账，请稍后查看",
    readyArgee: "我已阅读并同意",
    mogu1: "《蘑菇云隐私政策》",
    mogu2: "《蘑菇云服务协议》",
    and: "和",
    mesCodeSu: "获取验证码成功",
    regSu: "注册成功",
    findPassSu: "找回密码成功",
    copyTie: "近期复制或剪切过得文字",
    nullClipboard: "剪切板为空",
    screenshot: "云机截屏成功",
    batchScreenshots: "批量截图",
    equipment: "设备",
    eqEx: "设备已过期",
    eqFault: "设备故障",
    eqFail: "设备已失效",
    eqSingFail: "设备签名失效",
    refresh: "请不要频繁刷新",
    unablelink: "暂时无法链接，请稍后再试",
    replacementTit: "一键换机会导致数据丢失，是否继续？",
    replacementSu: "一键换机成功",
    replacementFa: "一键换机失败，请稍后再试",
    replacementNum: "一键换机权益包剩余可用次数为",
    isReplacement: "是否继续换机？",
    freeReplacement: "今日免费次数已用完，继续操作将产生 换机费用，是否继续？",
    isReboot: "确定要重启该云机吗？",
    isReset: "恢复出厂设置，将会清空该云机的所有数据，是否恢复？",
    reboot: "重启",
    reset: "重置",
    waiting: "中，预计需要1-2分钟",
    failure: "失败，请稍后再试",
    noBuySer: "没有购买服务",
    ipAgentSu: "IP代理成功",
    ipAgentFa: "IP代理失败",
    closeIpAgent: "关闭IP代理",
    copySu: "复制成功",
    delSu: "删除成功",
    delFa: "删除失败",
    uploadSu: "上传成功",
    uploadFa: "上传失败",
    reseting: "重置中",
    rebooting: "重启中"
  },
  activity: {
    selectPad: "选择机型（新用户免费体验3小时）",
    free: "免费试用",
    buy: "购买云机",
    length: "时长",
    valueExperience: "超值体验",
    afterPurchase: "复购无忧",
    buyNow: "立即购买"
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js